import { render, staticRenderFns } from "./DisclaimerModal.vue?vue&type=template&id=186209d4&scoped=true"
import script from "./DisclaimerModal.vue?vue&type=script&lang=ts"
export * from "./DisclaimerModal.vue?vue&type=script&lang=ts"
import style0 from "./DisclaimerModal.vue?vue&type=style&index=0&id=186209d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186209d4",
  null
  
)

export default component.exports